// Create actions for profiling
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_ERROR } from "./actionTypes";

export const loginRequest = (data, history) => {
  return {
    type: LOGIN_REQUEST,
    payload: { data, history },
  };
};

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginError = error => {
  return {
    type: LOGIN_ERROR,
    payload: error,
  };
};
